import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Button } from 'react-bootstrap';
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconAlert from 'components/common/IconAlert';
import Lottie from 'lottie-react';
import lottieClos from 'components/widgets/lottie-commandeClose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Axios } from 'helpers/axios';
import HabilitationService from 'services/habilitationsService';
import ConfigurationService from 'services/configurationService';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { formContact } from 'helpers/yupValidationSchema';

const NousContacter = () => {
    const [messageEnvoye, setMessageEnvoye] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, formState: { errors }, } = useForm({
        resolver: yupResolver(formContact),
    });

    const sendRequest = async (data) => {
        try {
            setIsLoading(true);
            await Axios.post('/publicRoutes/priseContact',{
                ...data
            });
            setMessageEnvoye(true);
            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    return (<>
        <h3 className='mt-3 mb-3'>Nous contacter</h3>
        <Row>
            <Col md={6}>
                <FalconComponentCard>
                    <FalconComponentCard.Header>Nos Coordonnées</FalconComponentCard.Header>
                    <FalconComponentCard.Body>
                        {HabilitationService && HabilitationService.habilitations && HabilitationService.habilitations.structures.length > 0 ?
                            <IconAlert icon={'phone'} variant={'warning'} className='mb-3'>
                                <h5>LIGNE D'URGENCE</h5>
                                Vous faites face à une <b>urgence</b> opérationnelle sur un Poste de Secours que nous assurons ? Un cadre opérationnel d'astreinte vous répond 24h/24 et 7j/7 au {' '}
                                <Link to={'tel:'+ConfigurationService.config['ligneAstreinte']}>{ConfigurationService.config['ligneAstreinte']}</Link>
                            </IconAlert>
                        : null}

                        <h6>Liens directs:</h6>
                        <ul>
                            <li><Link to="/demandeDPS">Je demande un poste de secours</Link></li>
                            <li><Link to="/recrutement">Je m'engage en tant que bénévole</Link></li>
                        </ul>
                        
                        <h6 className='mt-3'>Pour toute autre question:</h6>
                        <Link to={'tel:'+ConfigurationService.config['telSecretariat']}><FontAwesomeIcon icon={'phone'}/> {ConfigurationService.config['telSecretariat']}</Link><br/>
                        <Link to={"mailto:"+ConfigurationService.config['mailSecretariat']}><FontAwesomeIcon icon={'envelope'}/> {ConfigurationService.config['mailSecretariat']}</Link><br/>

                        <h6 className='mt-3'>Suivez nous !</h6>
                        {ConfigurationService.config['lienExterneFacebook'] ? <Link className='me-3' to={ConfigurationService.config['lienExterneFacebook']}><FontAwesomeIcon className='fs-6' icon={['fab', 'facebook']}/></Link> : null}
                        {ConfigurationService.config['lienExterneInstagram'] ? <Link className='me-3' to={ConfigurationService.config['lienExterneInstagram']}><FontAwesomeIcon className='fs-6' icon={['fab', 'instagram']}/></Link> : null}
                        {ConfigurationService.config['lienExterneLinkedin'] ? <Link className='me-3' to={ConfigurationService.config['lienExterneLinkedin']}><FontAwesomeIcon className='fs-6' icon={['fab', 'linkedin']}/></Link> : null}
                        {ConfigurationService.config['lienExterneTwitter'] ? <Link className='me-3' to={ConfigurationService.config['lienExterneTwitter']}><FontAwesomeIcon className='fs-6' icon={['fab', 'x-twitter']}/></Link> : null}

                    </FalconComponentCard.Body>
                </FalconComponentCard>
            </Col>
            <Col md={6}>
                <FalconComponentCard>
                    <FalconComponentCard.Header>Pour toute demande générique</FalconComponentCard.Header>
                    <FalconComponentCard.Body>
                        {messageEnvoye ?
                            <div className="wizard-lottie-wrapper">
                                <div className="wizard-lottie mx-auto">
                                <Lottie animationData={lottieClos} loop={false} />
                                </div>
                            </div>
                        :
                            <Form onSubmit={handleSubmit(sendRequest)}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom</Form.Label>
                                            <Form.Control type="text" name="nom" id="nom" {...register("nom")} isInvalid={!!errors.nom}/>
                                            <small className="text-danger">{errors.nom?.message}</small>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prénom</Form.Label>
                                            <Form.Control type="text" name="prenom" id="prenom" {...register("prenom")} isInvalid={!!errors.prenom}/>
                                            <small className="text-danger">{errors.prenom?.message}</small>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Adresse email</Form.Label>
                                            <Form.Control type="email" name="email" id="email" {...register("email")} isInvalid={!!errors.email}/>
                                            <small className="text-danger">{errors.email?.message}</small>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Téléphone</Form.Label>
                                            <Form.Control type="text" name="telephone" id="telephone" {...register("telephone")} isInvalid={!!errors.telephone}/>
                                            <small className="text-danger">{errors.telephone?.message}</small>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Votre message ou demande</Form.Label>
                                            <Form.Control as="textarea" rows={7} name="message" id="message" {...register("message")} isInvalid={!!errors.message}/>
                                            <small className="text-danger">{errors.message?.message}</small>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Button className="w-100" type="submit" disabled={isLoading}>Envoyer</Button>
                                </Form.Group>
                            </Form>
                        }
                    </FalconComponentCard.Body>
                </FalconComponentCard>
            </Col>
        </Row>
    </>);
};

export default NousContacter;